var React = require('react');

function IconHamburger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 12H14V10H0V12ZM0 7H14V5H0V7ZM0 0V2H14V0H0Z"}));
}

IconHamburger.defaultProps = {"viewBox":"0 0 14 12"};

module.exports = IconHamburger;

IconHamburger.default = IconHamburger;
